import { Autocomplete, Chip, TextField } from '@mui/material';
import { useState } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    root: {
        '& .MuiInputBase-root': {
            // Use minHeight to allow the control to grow when chips wrap to next line
            minHeight: theme.spacing(4.5),
            background: '#FFFF',
            borderRadius: theme.spacing(4.5),
            paddingRight: 0,
            '& > fieldset': {
                borderColor: '#E2E2E2',
            },
            '& input': {
                padding: theme.spacing(0, 1),
                height: '100%',
                fontSize: '12px',
                fontWeight: '500',
                position: 'relative',
                '&:focus': {
                    borderRadius: theme.spacing(4.5),
                },
            },
        },
    },
}));

const ChipsInput = ({
    name,
    label,
    placeholder,
    value,
    onChange,
    onBlur,
    size,
    variant,
    fullWidth,
    className,
    styleVariant = 'default',
    validateItem, // optional: (item: string) => boolean
    filterInvalid = false, // optional: if true, invalid items are removed before onChange
    invalidText, // optional helper text when there are invalid items
    error: errorProp,
    helperText: helperTextProp,
    ...props
}) => {
    const [inputValue, setInputValue] = useState('');
    const { classes, cx } = useStyles();

    // compute invalid items when validator provided
    const invalidItems = Array.isArray(value) && validateItem ? value.filter((v) => !validateItem(v)) : [];
    const hasInvalids = (validateItem && invalidItems.length > 0) || false;

    return (
        <Autocomplete
            multiple
            id={`chips-${name}`}
            options={[]}
            value={value}
            freeSolo
            onChange={(e, val) => {
                if (validateItem && filterInvalid) {
                    const filtered = val.filter((v) => validateItem(v));
                    onChange(filtered);
                } else {
                    onChange(val);
                }
            }}
            onBlur={onBlur}
            fullWidth={fullWidth}
            renderTags={(val, getTagProps) =>
                val.map((option, index) => {
                    const invalid = validateItem ? !validateItem(option) : false;
                    const { key, ...chipProps } = getTagProps({ index });
                    return (
                        <Chip
                            key={key}
                            label={option}
                            color={invalid ? 'error' : 'default'}
                            variant={invalid ? 'outlined' : 'filled'}
                            {...chipProps}
                        />
                    );
                })
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    className={cx({ [classes.root]: styleVariant === 'textFieldRounded' }, className)}
                    label={label}
                    placeholder={placeholder}
                    size={size}
                    variant={variant}
                    fullWidth={fullWidth}
                    error={errorProp ?? hasInvalids}
                    helperText={helperTextProp ?? (hasInvalids ? invalidText : undefined)}
                />
            )}
            inputValue={inputValue}
            onInputChange={(event, newValue, reason) => {
                if (reason === 'clear') {
                    onChange([]);
                } else {
                    setInputValue(newValue);
                }
            }}
            {...props}
        />
    );
};

export default ChipsInput;
